<template>
  <p class="text-h6 mb-6">
    {{ $t("component.notFoundModel.brandQuestion", { brand }) }}
  </p>
  <v-btn block color="primary" class="mb-3" @click="emit('yes')">
    {{ $t("component.notFoundModel.brandYes") }}
  </v-btn>
  <v-btn block color="primary" variant="outlined" @click="emit('no')">
    {{ $t("component.notFoundModel.brandNo") }}
  </v-btn>
</template>

<script setup lang="ts">
defineProps<{ brand: string }>();
const emit = defineEmits<{ yes: []; no: [] }>();
</script>
